import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { OrderListComponent } from './pages/order-list/order-list.component';
import { HttpErrorInterceptorService } from '../lib/lib-ngx/services/http-error-interceptor.service';
import { ConfirmationModalComponent } from './modals/confirmation-modal/confirmation-modal.component';
import { PickupOwnerModalComponent } from './modals/pickup-owner-modal/pickup-owner-modal.component';
import { HttpInterceptorVersionService } from '../lib/lib-ngx/services/http-interceptor-version.service';
import { APP_TOKEN, appInitializerFn } from '../lib/lib-ngx/services/AppInitializerFn';
import { VersionService } from '../lib/lib-ngx/services/version.service';
import { ConfigService } from '../lib/lib-ngx/services/config.service';
import { OrderStatusPipe } from './pipes/order-status.pipe';
import { ChronopostTrackingUrlPipe } from '../lib/lib-ngx/pipes/chronopost-tracking-url.pipe';

import packageJson from '../../package.json';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    OrderListComponent,
    ConfirmationModalComponent,
    PickupOwnerModalComponent,
    OrderStatusPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    MaskitoDirective,
    ChronopostTrackingUrlPipe,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true},
    {provide: APP_TOKEN, useValue: {name: packageJson.name, version: packageJson.version}},
    {provide: APP_INITIALIZER, useFactory: appInitializerFn, multi: true, deps: [ConfigService, VersionService, APP_TOKEN]},
    {provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorVersionService, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
